import React from 'react';
import { Award, GraduationCap, Heart } from 'lucide-react';
export function PhysicianProfileHodor() {
  return <div className="min-h-screen bg-gradient-to-b from-white to-[#f8faff] dark:from-[#0a0e17] dark:to-[#111827]" data-id="element-836">
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6" data-id="element-837">
        <div className="container mx-auto max-w-6xl" data-id="element-838">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-839">
            {/* Image */}
            <div className="flex justify-center" data-id="element-840">
              <div className="relative" data-id="element-841">
                <div className="absolute inset-0 bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] rounded-2xl blur-2xl opacity-20" data-id="element-842"></div>
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jtoD2woMih8P3b3oRePJt3/Dr._Hodor_Image.jpg" alt="Dr. Jonathan Hodor" className="relative rounded-2xl shadow-2xl w-full max-w-md" data-id="element-843" />
              </div>
            </div>

            {/* Info */}
            <div data-id="element-844">
              <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-845">
                <span className="bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-846">
                  Dr. Jonathan Hodor, DO, MS, ACOOG
                </span>
              </h1>
              <p className="text-xl text-gray-600 dark:text-gray-300 mb-6" data-id="element-847">
                Board Certified Maternal-Fetal Medicine Specialist & Healthcare
                Executive
              </p>
              <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400 mb-8" data-id="element-848">
                <Heart className="text-[#C85A15]" size={20} data-id="element-849" />
                <span data-id="element-850">
                  31+ years of clinical excellence and innovative care delivery
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bio Section */}
      <section className="py-16 px-6" data-id="element-851">
        <div className="container mx-auto max-w-4xl" data-id="element-852">
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30" data-id="element-853">
            <div className="flex items-center gap-3 mb-6" data-id="element-854">
              <div className="w-12 h-12 rounded-full bg-[#C85A15]/20 flex items-center justify-center" data-id="element-855">
                <Heart className="text-[#C85A15]" size={24} data-id="element-856" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-857">About Dr. Hodor</h2>
            </div>
            <div className="space-y-4 text-gray-600 dark:text-gray-300 text-lg leading-relaxed" data-id="element-858">
              <p data-id="element-859">
                Dr. Jonathan Hodor is a distinguished medical professional with
                a robust background spanning over 17 years in OB/GYN and
                Maternal-Fetal Medicine, complemented by 4+ years of expertise
                in Aesthetics and Regenerative/Integrative Health Services. As
                the Medical Director of RNR Aesthetics & Potomac Performance in
                Bethesda, MD, Dr. Hodor oversaw all modalities and services
                related to Aesthetics, Health, and Regenerative Therapies. Now
                he runs RNR Regenerative Therapeutics which is a highly focused
                entity involved with PEPTIDES / WEIGHT LOSS and HORMONE
                REPLACEMENT THERAPY.
              </p>
              <p data-id="element-860">
                Dr. Hodor is actively involved in Bio-Identical Hormone
                Replacement Therapy (BHRT), Weight Loss Therapies, and
                Integrative Wellness Therapies in particular, peptide therapies
                all of which showcase his commitment to comprehensive patient
                wellness. Previously, Dr. Hodor served as the Assistant Medical
                Director of Maryland Perinatal Associates, further demonstrating
                his leadership and expertise in medical management roles. With a
                passion for enhancing patient health and intentional aging, Dr.
                Hodor continues to be a driving force in the medical community,
                delivering exceptional care and innovative treatments to his
                patients.
              </p>
            </div>
          </div>

          {/* Certifications Section */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-861">
            <div className="flex items-center gap-3 mb-8" data-id="element-862">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center" data-id="element-863">
                <Award className="text-[#BBDDFF]" size={24} data-id="element-864" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-865">Board Certifications</h2>
            </div>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-866">
              <div className="flex items-start gap-3" data-id="element-867">
                <Award className="text-[#C85A15] flex-shrink-0 mt-1" size={20} data-id="element-868" />
                <div data-id="element-869">
                  <h3 className="font-semibold mb-1" data-id="element-870">
                    ACOOG Maternal-Fetal Medicine
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-871">
                    American College of Osteopathic Obstetrics & Gynecology
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-872">
                <Award className="text-[#C85A15] flex-shrink-0 mt-1" size={20} data-id="element-873" />
                <div data-id="element-874">
                  <h3 className="font-semibold mb-1" data-id="element-875">
                    ACOOG Obstetrics & Gynecology
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-876">
                    American College of Osteopathic Obstetrics & Gynecology
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Professional Affiliations */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-877">
            <div className="flex items-center gap-3 mb-8" data-id="element-878">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center" data-id="element-879">
                <GraduationCap className="text-[#BBDDFF]" size={24} data-id="element-880" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-881">Professional Affiliations</h2>
            </div>
            <div className="space-y-4" data-id="element-882">
              <div className="flex items-center gap-3" data-id="element-883">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-884"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-885">
                  <span className="font-semibold" data-id="element-886">SMFM</span> – Society for
                  Maternal-Fetal Medicine
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-887">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-888"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-889">
                  <span className="font-semibold" data-id="element-890">AIUM</span> – American
                  Institute of Ultrasound in Medicine
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-891">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-892"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-893">
                  <span className="font-semibold" data-id="element-894">ACOOG</span> – American
                  College of Osteopathic Obstetrics & Gynecology
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-895">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-896"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-897">
                  <span className="font-semibold" data-id="element-898">ACOG</span> – American College
                  of Obstetrics & Gynecology
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-899">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-900"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-901">
                  <span className="font-semibold" data-id="element-902">AOA</span> – American
                  Osteopathic Association
                </p>
              </div>
            </div>
          </div>

          {/* Licensed States */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-903">
            <div className="flex items-center gap-3 mb-8" data-id="element-904">
              <div className="w-12 h-12 rounded-full bg-[#C85A15]/20 flex items-center justify-center" data-id="element-905">
                <Award className="text-[#C85A15]" size={24} data-id="element-906" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-907">Licensed in 23 States</h2>
            </div>
            <div className="flex flex-wrap gap-3" data-id="element-908">
              {['NJ', 'MD', 'VA', 'WV', 'PA', 'TX', 'AZ', 'DE', 'MO', 'FL', 'GA', 'ME', 'AL', 'CO', 'MN', 'TN', 'NY', 'KY', 'CA', 'MI', 'HI', 'MS', 'CT'].map(state => <span key={state} className="bg-gradient-to-r from-[#BBDDFF]/20 to-[#C85A15]/20 px-4 py-2 rounded-full font-semibold" data-id="element-909">
                  {state}
                </span>)}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-6" data-id="element-910">
        <div className="container mx-auto max-w-4xl text-center" data-id="element-911">
          <div className="bg-gradient-to-r from-[#BBDDFF]/10 to-[#C85A15]/10 rounded-2xl p-12 border border-white/20 dark:border-gray-700/30" data-id="element-912">
            <h2 className="text-3xl font-bold mb-4" data-id="element-913">
              Ready to Start Your Journey?
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 mb-8" data-id="element-914">
              Dr. Hodor is here to support you with personalized care tailored
              to your needs.
            </p>
            <a href="https://staging.joinomu.com/patient/onboarding" target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-gradient-to-r from-[#C85A15] to-[#FF8A3D] text-white font-medium py-3 px-8 rounded-full hover:shadow-lg transition-all" data-id="element-915">
              Get Started Today
            </a>
          </div>
        </div>
      </section>
    </div>;
}